
    import { mapActions } from 'vuex';

    export default {
        data() {
            return {
                selectedCategory: 'all',
                isFilterScrolledToLeft: true,
                projectCategories: [],
                isShowArrowButtons: true
            };
        },
        computed: {
            projectsData() {
                return this.$store.state.projectsData;
            },
            filteredProjects() {
                if (this.selectedCategory === 'all') {
                    return this.projectsData;
                }

                return this.projectsData.filter(
                    (project) => project.acf.project_page_category === this.selectedCategory,
                );
            },
        },
        mounted() {
            this.getProjects();
            document.getElementById('filter-wrapper')
                .addEventListener('scroll', this.onFilterScroll);
            window.addEventListener("resize", this.showArrowButtons);
        },
        beforeDestroy() {
            window.removeEventListener("resize", this.showArrowButtons);
        },
        updated() {
            this.showArrowButtons();
        },
        methods: {
            ...mapActions([
                'setProjectsData',
            ]),
            showArrowButtons() {
                if (this.projectCategories.length) {
                    const parentDiv = document.getElementById("filter-wrapper");
                    const childDiv = parentDiv.querySelectorAll("#filter-wrapper button");
                    let sumWidths = 0;
                    childDiv.forEach((childDiv) => {
                        sumWidths += childDiv.clientWidth;
                    });
                    this.isShowArrowButtons = sumWidths > (parentDiv.clientWidth - 30);
                }
            },
            setSelectedCategory(category) {
                this.selectedCategory = category;
            },
            scrollLeft() {
                const filter = document.getElementById('filter-wrapper');
                filter.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            },
            scrollRight() {
                const filter = document.getElementById('filter-wrapper');
                filter.scroll({
                    top: 0,
                    left: 1000,
                    behavior: 'smooth',
                });
            },
            onFilterScroll() {
                const filter = document.getElementById('filter-wrapper');
                this.isFilterScrolledToLeft = filter.scrollLeft === 0;
            },
            getProjects() {
                this.$getDataFromCache(`/wp-json/wp/v2/projects?per_page=100`)
                    .then((response) => {
                        this.setProjectsData(response.data);
                        this.setProjectCategories(this.projectsData);
                    });
            },
            setProjectCategories(projects) {
                const allCategories = projects.map((project) => project.acf.project_page_category);
                this.projectCategories = [...new Set(allCategories)];
            },
        },
    };
